import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../wayfinder'
import callback5c456a from './callback'
/**
* @see \App\Http\Controllers\Auth\User\Login\AppleCallbackBounceController::__invoke
* @see app/Http/Controllers/Auth/User/Login/AppleCallbackBounceController.php:20
* @route '/auth/login/apple/callback'
*/
export const callback = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: callback.url(options),
    method: 'post',
})

callback.definition = {
    methods: ["post"],
    url: '/auth/login/apple/callback',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\User\Login\AppleCallbackBounceController::__invoke
* @see app/Http/Controllers/Auth/User/Login/AppleCallbackBounceController.php:20
* @route '/auth/login/apple/callback'
*/
callback.url = (options?: RouteQueryOptions) => {
    return callback.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\User\Login\AppleCallbackBounceController::__invoke
* @see app/Http/Controllers/Auth/User/Login/AppleCallbackBounceController.php:20
* @route '/auth/login/apple/callback'
*/
callback.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: callback.url(options),
    method: 'post',
})

const apple = {
    callback: Object.assign(callback, callback5c456a),
}

export default apple